import api from '../utils/api';

export const getLatestJobNumber = () => {
  return api().get('/job/latest_job_number/');
};

export const createJob = (data, config) => {
  return api().post('/job/', data, config);
};

export const updateJobWithFiles = (id, data, config) => {
  return api().put(`/job/${id}/`, data, config);
};

export const cancelJob = (id, data) => {
  return api().post(`/job/${id}/cancel_job/`, data);
};

export const getAllJobs = (params) => {
  return api().get('/job/', { params });
};

export const getJob = (id) => {
  return api().get(`/job/${id}`);
};

export const getJobTaskAnalytics = (id, params) => {
  return api().get(`/job/${id}/task_analytics`, { params });
};

export const getJobTaskLogs = (id, params) => {
  return api().get(`/job/${id}/task_logs`, { params });
};

export const getJobTaskLogsV2 = (id, params) => {
  return api().get(`/job/${id}/task_logs_v2`, { params });
};

export const updateColumnMappings = (id, data, params) => {
  return api().patch(`/job/${id}/update_column_mapping/`, data, { params });
};

export const getPresignedUrl = (id, data) => {
  return api().post(`/job/${id}/get_presigned_urls/`, data);
};

export const getJobDocuments = (id) => {
  return api().get(`/job/${id}/uploaded_files/`);
};

export const getDownloadUrl = (id, params) => {
  return api().get(`/job/${id}/generate_download_url/`, { params });
};

export const skipExceptionSummary = (id, data) => {
  return api().post(`/job/${id}/skip_exception_summary/`, data);
};

export const getActivityLog = (params) => {
  return api().get('/job_activity/', { params });
};

export const generateThread = (id, data) => {
  return api().post(`/job/${id}/generate_thread/`, data);
};

export const sendChatMessage = (data) => {
  return api().post(`/assistant/chat/`, data);
};

export const getLoanPricingSummaryHistory = (data) => {
  return api().get(`/assistant/loan_pricing_summary_history/`, { params: data });
};

export const getTaskAssistantChatHistory = (data) => {
  return api().get(`/assistant/chat_history/`, { params: data });
};

export const addInSummary = (data) => {
  return api().post(`/assistant/add_in_summary/`, data);
};

export const getSummaryHeaders = (data) => {
  return api().get(`/assistant/summary_header/`, { params: data });
};

export const updateSummaryHeaders = (data) => {
  return api().patch(`/assistant/update_summary_header/`, data);
};

export const getAssistantThreads = (job_id, data) => {
  return api().get(`/job/${job_id}/threads/`, { params: data });
};

export const getJobAssistantChatHistory = (data) => {
  return api().get(`/assistant/chat_history/`, { params: data });
};

export const getLoanFundAllocations = (jobId, data) => {
  return api().get(`/job/${jobId}/loan_fund_allocations`, { params: data });
};

export const setAllocationFund = (jobId, data) => {
  return api().patch(`/job/${jobId}/set_allocation_fund/`, data);
};

export const updateAllocationFinalization = (jobId, data) => {
  return api().patch(`/job/${jobId}/update_allocation_finalization/`, data);
};

export const getAllocationDetails = (jobId, data) => {
  return api().get(`/job/${jobId}/allocation_details/`, { params: data });
};

export const updateAllocationDetails = (jobId, data) => {
  return api().patch(`/job/${jobId}/update_allocation_details/`, data);
};

export const getFunds = (jobId, params) => {
  return api().get(`/job/${jobId}/get_funds/`, { params });
};
